import { MInsurance } from '@Models/client/insurance.model'
import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    insurances: MInsurance,
    metadata: {},
}

const InsuranceReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_INSURANCES:
            return {
                ...state,
                insurances: action.payload?.data?.map(
                    (insurance: MInsurance) => new MInsurance(insurance)
                ),
                metadata: action?.payload?.metadata,
            }

        default:
            return { ...state }
    }
}

export default InsuranceReducer
